import React from 'react';


import AudioButton from "../common/AudioButton/AudioButton";
import { ImageCard } from "../common/ImageCard/ImageCard";
import { Controls } from "../../Controls";

import { ListenProps } from "./Listen.type";

import './styles.scss';

export const Listen: React.FC<ListenProps> = ({
  images,
  audio,
  controls,
}) => {
  const { handlePrev, handleNext, lastItemIndex, currentIndex } = controls;

  return (
    <>
    <div className="ImagesContainer">
      {!!images?.length && images.map(imagePath => <ImageCard path={imagePath}/>)}
    </div>
    {!!audio && (<AudioButton src={audio} currentIndex={currentIndex}/> )}
      <Controls handlePrev={handlePrev} handleNext={handleNext} currentIndex={currentIndex} lastItemIndex={lastItemIndex}/>
    </>
  );
};
